import { Select } from 'antd';
import React, { memo, useEffect, useState } from 'react';
import { useDebounce } from '../../hook/use-debounce';

type Props = {
  loadData: (query: string) => Promise<any[]>;
  value?: string;
  onChange: (value: string) => void;
  placeholder?: string;
  showSearch?: boolean;
  style?: React.CSSProperties;
  disabled?: boolean;
  payload?: any;
  filter?: any;
};

const QuerySearch = memo(
  ({
    loadData,
    value,
    onChange,
    placeholder = 'Хайх...',
    showSearch = true,
    style,
    disabled,
    payload: _payload,
    filter: _filter,
  }: Props) => {
    const [text, setText] = useState<string>('');
    const query = useDebounce(text, 300);
    const [options, setOptions] = useState<{ label: string; value: string }[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [payload, setPayload] = useState<any>();

    useEffect(() => {
      const fetchData = async () => {
        setLoading(true);
        try {
          const res = await loadData(payload ? { query, ...payload } : { query: query });
          const mapped = res.map((item) => ({
            label: item.name ? item.name : `${item.lastName} ${item.firstName}`,
            value: item.id,
          }));
          setOptions(mapped);
        } catch (error) {
          console.error('QuerySearch loadData error:', error);
          setOptions([]);
        } finally {
          setLoading(false);
        }
      };

      fetchData();
    }, [query, loadData, payload]);

    React.useEffect(() => {
      setPayload(_payload);
    }, [_payload]);

    return (
      <Select
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        showSearch={showSearch}
        onSearch={setText}
        options={options}
        style={style}
        loading={loading}
        filterOption={false}
        allowClear
        disabled={disabled}
      />
    );
  }
);

QuerySearch.displayName = 'QuerySearch';

export { QuerySearch };
